import React from "react";
import { User, Phone, Calendar, Clock, AlertCircle } from "lucide-react";
import { formatDate } from "./constants";

export default function ReviewSummary({ selectedType, formData, selectedDate, selectedSlot }) {
  const basePrice = selectedType?.price || 0;
  const gstAmount = Math.round(basePrice * 0.18);
  const totalAmount = basePrice + gstAmount;

  return (
    <div className="bg-surface border border-border_custom p-6 mb-6 rounded-xl space-y-4">
      <div className="pb-4 border-b border-border_custom">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="font-serif text-lg text-emerald_deep">{selectedType?.title}</h3>
            <p className="text-sm text-text_muted">{selectedType?.subtitle} &mdash; {selectedType?.duration}</p>
          </div>
        </div>
        <div className="space-y-2">
          <div className="flex justify-between text-sm" data-testid="review-base-price">
            <span className="text-text_muted">Consultation Fee</span>
            <span className="text-emerald_deep">{"\u20B9"}{basePrice.toLocaleString()}</span>
          </div>
          <div className="flex justify-between text-sm" data-testid="review-gst">
            <span className="text-text_muted">GST (18%)</span>
            <span className="text-emerald_deep">{"\u20B9"}{gstAmount.toLocaleString()}</span>
          </div>
          <div className="flex justify-between items-center pt-2 border-t border-border_custom" data-testid="review-total">
            <span className="font-serif text-base text-accent">Total</span>
            <span className="font-serif text-2xl text-emerald_deep">{"\u20B9"}{totalAmount.toLocaleString()}</span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 py-2">
        <div><p className="text-xs text-accent uppercase tracking-wider mb-1">Name</p><p className="text-emerald_deep flex items-center gap-2"><User size={14} className="text-accent" />{formData.name}</p></div>
        <div><p className="text-xs text-accent uppercase tracking-wider mb-1">Phone</p><p className="text-emerald_deep flex items-center gap-2"><Phone size={14} className="text-accent" />{formData.phone}</p></div>
      </div>
      {selectedDate && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 py-2 border-t border-border_custom">
          <div><p className="text-xs text-accent uppercase tracking-wider mb-1">Preferred Date</p><p className="text-emerald_deep flex items-center gap-2"><Calendar size={14} className="text-accent" />{formatDate(selectedDate)}</p></div>
          <div><p className="text-xs text-accent uppercase tracking-wider mb-1">Preferred Slot</p><p className="text-emerald_deep flex items-center gap-2"><Clock size={14} className="text-accent" />{selectedSlot}</p></div>
        </div>
      )}
      <div className="pt-4 border-t border-border_custom">
        <p className="text-xs text-accent uppercase tracking-wider mb-1">Health Concern</p>
        <p className="text-sm text-text_muted">{formData.health_concern}</p>
      </div>
      <div className="bg-accent/5 border border-accent/20 p-4 mt-4 rounded-lg">
        <div className="flex items-start gap-2">
          <AlertCircle size={14} className="text-accent mt-0.5 flex-shrink-0" />
          <div className="text-xs text-text_muted">
            <p>Please share your reports at least 1 day prior to the consultation.</p>
            <p className="mt-1">Our team will confirm your preferred slot or suggest the nearest available time.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
